var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2482 2.75779e-07H1.05423C0.910049 -0.000123345 0.768886 0.0413159 0.647648 0.119356C0.526411 0.197396 0.430237 0.308728 0.370645 0.44002C0.311053 0.571312 0.290569 0.716999 0.311646 0.859633C0.332722 1.00227 0.394466 1.1358 0.489482 1.24425L4.46598 5.78775C4.58558 5.92461 4.65141 6.10025 4.65123 6.282V9.9375C4.65123 9.99572 4.66479 10.0531 4.69082 10.1052C4.71686 10.1573 4.75466 10.2026 4.80123 10.2375L7.05123 11.925C7.10694 11.9668 7.17319 11.9922 7.24255 11.9985C7.31191 12.0047 7.38165 11.9916 7.44394 11.9604C7.50623 11.9293 7.55861 11.8814 7.59523 11.8221C7.63184 11.7629 7.65123 11.6946 7.65123 11.625V6.282C7.65105 6.10025 7.71688 5.92461 7.83648 5.78775L11.813 1.2435C12.2375 0.759 11.8925 2.75779e-07 11.2482 2.75779e-07Z",
    fill: "#CAD0D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFilled);
export default __webpack_public_path__ + "static/media/filter-filled.3f909b85.svg";
export { ForwardRef as ReactComponent };